import React from 'react'
import { Paper, Typography, Button, CircularProgress } from '@mui/material'

const PRICE = 0

function MailMarketingInfo({ onSubmit, saving }) {
  return (
    <div>
      <Typography variant='h4'>Sähköpostimarkkinointi</Typography>
      <Paper style={{ margin: 20, padding: 20 }}>
        <Typography
          variant='body1'
          style={{ marginBottom: 25 }}
          component={'p'}
        >
          Sähköpostimarkkinointi työkalulla voit lähettää sähköpostiviestejä listoille jotka olet luonut.
        </Typography>
        <Typography
          variant='body1'
          style={{ marginBottom: 25 }}
          component={'p'}
        >
        </Typography>
        <Typography
          variant='body1'
          style={{ marginBottom: 30 }}
          component={'p'}
        >
          Voit ottaa ominaisuuden käyttöön tästä. Kuukausimaksua ei ole. Viestit maksavat 1€ per 1000 viestiä. 
        </Typography>
        <Button
          disabled={saving}
          variant='contained'
          color='primary'
          onClick={() => onSubmit(PRICE)}
        >
          {saving ? <CircularProgress size={25} color='info' /> : 'Ota käyttöön'}
        </Button>
      </Paper>
      {/* <img src={infoimage} alt='Proshop-info' /> */}
    </div>
  )
}

export default MailMarketingInfo
